<p-tabView>
  <p-tabPanel
    class="table-header-verde-bottom-blanco"
    header="{{ 'CAPACIDADPAGOOCUPACION.LBL_CAPACIDADPAGO' | translate }}">

    <form [formGroup]="formulario" *ngIf="!cargando">
      <div class="grid form-group">
        <div class="col-3 md:col-3 lg:col-3">
          <div class="div-form">
            <label *ngIf="tipOcupacion?.nombreTipoOcupacion" class="falso-combo-texto">{{tipOcupacion.nombreTipoOcupacion}}</label>
          </div>
        </div>
        <div formArrayName="decisionCapacidadPago" class="grid col-4">
          <div
            *ngFor="let item of listasDecisionesCapacidadPagoOcupaciones; let i = index"
            class="col-12 md:col-4 lg:col"
          >
            <p-checkbox
              [formControlName]="i"
              [label]="item.nombre"
              binary="true"
              (onChange)="indicadorDecision(i,$event)"
            ></p-checkbox>
          </div>
        </div>
        <div class="col-12 md:col-6 lg:col-2">
          <div class="div-form">
            <p-dropdown disableTab [disableControl]="!indicadorFijarUno"  id="idTipoOcupacion" name="nomTipoOcupacion" [options]="selectListaFuentescapacidadPago" filter="filter"
                        placeholder="{{ 'LBL_SELECCIONE' | translate}}" emptyFilterMessage="{{ 'LBL_SINRESULTADOS' | translate}}"
                        emptyMessage="{{ 'LBL_SINRESULTADOS' | translate}}" optionValue="value" optionLabel="label" (onChange)="guardarSeleccionado()"
                        formControlName="idFuenteCapacidadPago"
            ></p-dropdown>
          </div>
        </div>
      </div>
    </form>

    <p-table
      [columns]="columnas" [loading]="carTabla" #dt
      [value]="ocupacionConfiguracionCapacidadPago" selectionMode="single" dataKey="idTipoOcupacionConfiguracion"
      [paginator]="false"   paginatorPosition="bottom"
    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
            {{col.header}}
            <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body"  let-row let-index="rowIndex">
        <tr>
          <td>{{row.fuenteCapacidadPago}}</td>
          <td class="text-center">
            <p-checkbox [(ngModel)]="row.indicadorPorcentajePerfil" binary="true" name="indicadorPorcentajePerfil"
                        #indPerfil (onChange)="actualizarRegistro(row)"></p-checkbox>
          </td>
          <td class="text-center">
            <p-checkbox [(ngModel)]="row.indicadorEstimadorGasto" binary="true" name="indicadorEstimadorGasto"
                        #indEstimador (onChange)="actualizarRegistro(row)"></p-checkbox>
          </td>
          <td class="text-center">
            <p-checkbox [(ngModel)]="row.indicadorAplicaGastoIncome" binary="true" name="indicadorAplicaGastoIncome"
                        #indIncome (onChange)="actualizarRegistro(row)"></p-checkbox>
          </td>
          <td class="text-center">
            <p-checkbox [(ngModel)]="row.indicadorTransferenciaAch" binary="true" name="indicadorTransferenciasACH"
                        #indAch (onChange)="actualizarRegistro(row)"></p-checkbox>
          </td>
          <td class="text-center">
            <p-checkbox [(ngModel)]="row.indicadorLanzaNoAplicaOferta" binary="true" name="indicadorLanzaNoAplicaOferta"
                        #indNoOferta (onChange)="actualizarRegistro(row)"></p-checkbox>
          </td>
          <td class="text-center">
            <p-checkbox [(ngModel)]="row.indicadorHabilitado" binary="true" name="indicadorHabilitado"
                        #indHabilitado (onChange)="actualizarRegistro(row)"></p-checkbox>
          </td>

        </tr>
      </ng-template>
    </p-table>

  </p-tabPanel>

  <p-tabPanel
    header="{{ 'CAPACIDADPAGOOCUPACION.LBL_DESCUENTO' | translate }}">

    <form [formGroup]="formDesSalarios" *ngIf="!cargando " novalidate id="FormularioDescuento">
      <div class="grid form-group">
        <div class="col-12 md:col-4 lg:col-2">
          <div class="div-form">
            <label>* {{ 'CAPACIDADPAGOOCUPACION.LBL_DESDESMLV' | translate }} </label>
            <input type="text" pInputText id="desde"
                   name="desde"
                   autocomplete="off"
                   numero-decimal-reactive [decimales]="2" [maximo]="999999"
                   formControlName="desde"
                   *ngIf="!mayorDesde"
            >
            <div class="div-form">
              <label *ngIf="mayorDesde" class="falso-combo-texto">{{mayorDesde}}</label>
            </div>
            <div class="p-message p-messages-error p-corner-all" *ngIf="summit && fd.desde.invalid">
              {{ 'CAPACIDADPAGOOCUPACION.LBL_DESDESMLV' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-2">
          <div class="div-form">
            <label>* {{ 'CAPACIDADPAGOOCUPACION.LBL_HASTASMLV' | translate }} </label>
            <input type="text" pInputText id="hasta"
                   name="hasta"
                   autocomplete="off"
                   numero-decimal-reactive [decimales]="2" [maximo]="999999"
                   formControlName="hasta"
            >
            <div class="p-message p-messages-error p-corner-all" *ngIf="summit && fd.hasta.invalid" >
              {{ 'CAPACIDADPAGOOCUPACION.LBL_HASTASMLV' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
            <div class="p-message p-messages-error p-corner-all" *ngIf="summit && (fd.hasta.value >= 0 && fd.hasta.value < fd.desde.value)" >
              {{ 'CAPACIDADPAGOOCUPACION.LBL_HASTASMLVMAYOR' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-2">
          <div class="div-form">
            <label>* {{ 'CAPACIDADPAGOOCUPACION.LBL_DESCUENTOS' | translate }} </label>
            <input type="text" pInputText id="descuento"
                   name="descuento"
                   autocomplete="off"
                   porcentaje-reactive [decimales]="2"
                   formControlName="porcentajeDescuentoLey"
            >
            <div class="p-message p-messages-error p-corner-all" *ngIf="summit && fd.porcentajeDescuentoLey.invalid" >
              {{ 'CAPACIDADPAGOOCUPACION.LBL_DESCUENTOS' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>
        <div class="col-12 md:col-4 lg:col-2">
          <div class="div-form">
            <label>* {{ 'CAPACIDADPAGOOCUPACION.LBL_IMPUESTOS' | translate }} </label>
            <input type="text" pInputText id="impuesto"
                   name="impuesto"
                   autocomplete="off"
                   porcentaje-reactive [decimales]="2"
                   formControlName="porcentajeImpuesto"
            >
            <div class="p-message p-messages-error p-corner-all" *ngIf="summit && fd.porcentajeImpuesto.invalid">
              {{ 'CAPACIDADPAGOOCUPACION.LBL_IMPUESTOS' | translate}} {{ 'LBL_REQUERIDO' | translate}}
            </div>
          </div>
        </div>

        <div class="md:col-4 lg:col-2" style="align-items: center; padding-top: 30px;">
          <div class="div-form" >
            <button icon="fa fa-plus" label="{{'BTN_GUARDAR' | translate }}"
                    pButton
                    (click)="guardarDescuentoSalario()"
            ></button>
          </div>
        </div>

      </div>
    </form>
    <p-table
      [columns]="columnasDescuentoSalarioXley" [loading]="carTablaDescuentos" #dtSalarioXley
      [value]="configuracionesDescuentosSalarios" selectionMode="single" dataKey="descuentoSalarioXley"
      [paginator]="true" [rows]="10"  paginatorPosition="bottom"     class="table-header-verde-bottom-blanco"

    >
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
            {{col.header}}
            <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body"  let-row let-index="rowIndex">
        <tr>
          <td class="text-center" >{{row.desde}}</td>
          <td class="text-center" >{{row.hasta}}</td>
          <td class="text-center" >{{row.porcentajeDescuentoLey}}%</td>
          <td class="text-center" >{{row.porcentajeImpuesto}}%</td>
          <td class="text-center">
            <div class="btn-group" role="group">
              <button type="button" class="p-button btn" icon="fa fa-trash" data-toggle="tooltip"
                      title="{{'BTN_INHABILITAR' | translate}}" pButton pRipple (click)="inhabiltarRegistro(row)"></button>
              <button type="button" class="p-button p-button-success btn" icon="fa fa-pencil" data-toggle="tooltip"
                      title="{{'BTN_EDITAR' | translate}}" pButton pRipple (click)="editarSeleccionado(row)" ></button>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

  </p-tabPanel>

</p-tabView>
